
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const UPDATE_USER_DATA_SUCCESS = 'UPDATE_USER_DATA_SUCCESS';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';